module.exports = __webpack_public_path__ + "img/schnittkante_anthrazitgrau_ral7016.848fbc64.jpg";